import { CityData, OfficeData } from "@/types";

export const isCityData = (entity: CityData | OfficeData): entity is CityData => {
    return 'projects' in entity && 'last_files_update' in entity;
}; 